module.exports = __webpack_public_path__ + "img/map_photo-image.2ab233ac.jpg";